import $ from 'jquery'
import Splide from '@splidejs/splide'

$('.js-products-slider').each(function () {
    var $this = $(this);
    var splideInstance = new Splide($this[0], {
        pagination: false,
        arrows: false,
        perPage: 4,
        gap: '30px',
        breakpoints: {
            992: {
                destroy: true,
            },
        }
    });

    splideInstance.mount();
});